/**
 * @fileoverview Agent definition for draft-refiner-comparison-v2.
 *
 * This is a COMPOSITE agent that orchestrates:
 * 1. draft-refiner-v2 × N: Run refinement in parallel with different models
 *
 * Used to compare refinement outputs across different AI models.
 *
 * @category writing.refinement
 * @type composite
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
export const definition: AppAgentDefinition = {
  id: 'draft-refiner-comparison-v2',
  kind: 'composite',
  name: 'Draft Refiner Comparison',
  description:
    'Runs draft-refiner-v2 in parallel with different models to compare refinement outputs.',
  category: 'writing',
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'composite',
    addedIn: '2026-01',
    lastUpdated: '2026-01',
    taxonomyPath: 'writing.refinement.comparison',
    usedBy: ['RefinementComparisonPanel', 'use-comparison-refinements.ts'],
    composedOf: ['draft-refiner-v2'],
    relatedAgents: ['chapter-drafter-comparison-v2', 'prose-expander-comparison-v2', 'prose-shortener-comparison-v2'],
  },
};
